import { NovelSceneSchema, CoreEntityType, NovelActTree } from '#/index';
import { PointOfView } from '../plugins/prompt-engine/types';

interface NovelTreeFilter {
  actIds?: string[];
  chapterIds?: string[];
  sceneIds?: string[];
  characterIds?: string[];
  povs?: PointOfView[]
}

// 根据筛选条件获取小说树
export const getNovelActTree = (novelActsTree: NovelActTree[], filter: NovelTreeFilter = {}): NovelActTree[] => {
  const { povs, actIds, chapterIds, sceneIds, characterIds } = filter;

  const filterTree = (tree: NovelActTree): NovelActTree | null => {
    // 场景节点：检查所有筛选条件
    if (tree.data.type === CoreEntityType.NovelScenes) {
      const sceneData = tree.data as NovelSceneSchema;
      const scenePov = sceneData.attributes.pov;

      // 检查场景ID筛选
      if (sceneIds?.length && !sceneIds.includes(tree.id)) {
        return null;
      }

      // 检查视角筛选
      if (scenePov && povs?.length) {
        // 是否匹配视角
        const isMatch = povs.some(pov => pov.value === scenePov.type
          && (scenePov.characterId ? scenePov.characterId === pov.characterId : true))
        if (!isMatch) {
          return null;
        }
      }

      // 检查角色筛选
      if (characterIds?.length) {
        const isMatch = characterIds.some(characterId => scenePov?.characterId === characterId
          || sceneData.relationships.references.includes(characterId))
        if (!isMatch) {
          return null;
        }
      }

      return tree;
    }

    // 章节节点：检查章节ID筛选
    if (tree.data.type === CoreEntityType.NovelChapters) {
      if (chapterIds?.length && !chapterIds.includes(tree.id)) {
        return null;
      }
    }

    // 卷节点：检查卷ID筛选
    if (tree.data.type === CoreEntityType.NovelActs) {
      if (actIds?.length && !actIds.includes(tree.id)) {
        return null;
      }
    }

    // 卷/章节节点：递归过滤子节点
    if (tree.children?.length) {
      const filteredChildren = tree.children.map(filterTree).filter(Boolean) as NovelActTree[];
      return filteredChildren.length ? { ...tree, children: filteredChildren } : null;
    }

    return null;
  };

  return novelActsTree.map(filterTree).filter(Boolean) as NovelActTree[];
};